//
//  OSSLisence.tsx
//
//  isana.net,inc. Proprietary and Confidential
//
import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";

const OSSLisence = () => {
  function createDate(name: string, version: string, lisence: React.ReactNode) {
    return { name, version, lisence };
  }

  const rows = [
    createDate(
      "@emotion/react",
      "11.11.1",
      <Link to="https://github.com/emotion-js/emotion/blob/fef1ea086fbec998caaa016a5ecdace4bbb9d749/LICENSE">
        MIT
      </Link>
    ),
    createDate(
      "@emotion/styled",
      "11.11.0",
      <Link to="https://github.com/emotion-js/emotion/blob/1135f8e9d97ea711eb483368313afdfe7b176845/LICENSE">
        MIT
      </Link>
    ),
    createDate(
      "@mui/material",
      "5.14.5",
      <Link to="https://github.com/mui/material-ui/blob/61fbfd1546c55caca984695a41f9c95668d414fc/LICENSE">
        MIT
      </Link>
    ),
    createDate(
      "axios",
      "1.4.0",
      <Link to="https://github.com/axios/axios/blob/21a5ad34c4a5956d81d338059ac0dd34a19ed094/LICENSE">
        MIT
      </Link>
    ),
    createDate(
      "axios-mock-adapter",
      "1.22.0",
      <Link to="https://github.com/ctimmerm/axios-mock-adapter/blob/master/LICENSE">
        MIT
      </Link>
    ),
    createDate(
      "crypto-js",
      "4.1.1",
      <Link to="https://github.com/brix/crypto-js/blob/7c26cc72a618053c294309c22c95a895af39b7b7/LICENSE">
        MIT
      </Link>
    ),
    createDate(
      "firebase",
      "10.3.1",
      <Link to="https://github.com/firebase/firebase-js-sdk/blob/b63d84d99bc87a531cb153d6a48de276d1579a1b/LICENSE">
        Apache License 2.0
      </Link>
    ),
    createDate(
      "firebase-admin",
      "11.10.1",
      <Link to="https://github.com/firebase/firebase-admin-node/blob/0ecf3740a22b13b42a3c72667d605ec93c719478/LICENSE">
        Apache License 2.0
      </Link>
    ),
    createDate(
      "react",
      "18.2.0",
      <Link to="https://github.com/facebook/react/blob/main/LICENSE">MIT</Link>
    ),
    createDate(
      "react-dom",
      "18.2.0",
      <Link to="https://github.com/facebook/react/blob/9e3b772b8cabbd8cadc7522ebe3dde3279e79d9e/LICENSE">
        MIT
      </Link>
    ),
    createDate(
      "react-router-dom",
      "6.8.1",
      <Link to="https://github.com/remix-run/react-router/blob/6bbd48c093d2ab2fd9e94405db1cdfba045ae295/LICENSE.md">
        MIT
      </Link>
    ),
    createDate(
      "react-script",
      "2.0.5",
      <Link to="https://github.com/facebook/create-react-app/blob/7a6a9b50b6d3cfc4fed2ae7d432a7419cbfbbfbe/LICENSE">
        MIT
      </Link>
    ),
    createDate(
      "web-vitals",
      "2.1.4",
      <Link to="https://github.com/GoogleChrome/web-vitals/blob/71ac4a03c4c71861196925275e803a05ad017723/LICENSE">
        Apache License 2.0
      </Link>
    ),
  ];
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 350 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">name</TableCell>
            <TableCell align="left">version</TableCell>
            <TableCell align="left">lisence</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell align="center" component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="left">{row.version}</TableCell>
              <TableCell align="left">{row.lisence}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OSSLisence;
